export default {
    event: function(eventName){
        window.gtag('event', eventName);
    }
}